import { ControllerBase } from "controllerBase";
import { Paginator } from "paginator";
const ko = require('knockout')
import global from 'globalMU'


declare var window:any

const PendenciaClienteOrcamentoController = ControllerBase.extend({
    name: "PendenciaClienteOrcamentoController",

    framework: "knockout",

    ajax: function () {

        return {
            url: "/Cliente/_Pendencias",
            type: "post"
        };
    },

    newModel: function () {

        var data = $.extend({
            SenhaOrcamentosAberto: null,
            SenhaVendedorRelacionado: null,
            DataInicial: null,
            DataFinal: null
        },
            this.data);

        return data;

    },

    aposBinding: function () {

        if (!this.data.ExistemPedidosEmAbertoClienteException ||
            !this.data.ExistemPedidosEmAbertoClienteException.Pedidos) {
            return;
        }

        this.atualizarPaginador(this.data.ExistemPedidosEmAbertoClienteException.Pedidos);
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    atualizarPaginador: function (data) {

        this.paginador = new Paginator({
            container: "#page-modalOrcamentoEmAberto",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    paginar: function (e) {
        this.pesquisar(e.page);
    },

    pesquisar: function (pagina) {

        var self = this;

        if (!this.filtros &&
            this.data.ExistemPedidosEmAbertoClienteException &&
            this.data.ExistemPedidosEmAbertoClienteException.Filtros) {
            this.filtros = this.data.ExistemPedidosEmAbertoClienteException.Filtros;
        }

        this.filtros.NumeroPagina = pagina;
        // FNX-4937 - this.filtros.DataInicial = this.model.DataInicial();
        // FNX-4937 - this.filtros.DataFinal = this.model.DataFinal();
        this.filtros.DataInicial = $("#pendenciaOrcamentoCliente_DataInicial").val(); // FNX-4937
        this.filtros.DataFinal = $("#pendenciaOrcamentoCliente_DataFInal").val(); // FNX-4937
        this.filtros.CodigoFilial = this.orcamento.get("CodigoFilialOrcamento"); // FNX-4937

        global.ajax({
            url: "/Orcamento/ListarPedidosEmAberto",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({ filtros: this.filtros }),
            success: function (data) {

                if (!data) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);

                self.model.ExistemPedidosEmAbertoClienteException().Pedidos.Entities(m());
                self.atualizarPaginador(data);

            }
        });

    },

    filtrar: function () {

        if (!global.isFormValid("#form-filtrar-orcamentoEmAberto")) {
            return;
        }

        this.pesquisar(1);

    },

    cancelar: function () {
        this.hide();
        $("#form-pesquisa-clientes-container").show();
    },

    definirCliente: function (model, element) {

        var formOrcamentoAbertoValido = this.model.ExistemPedidosEmAbertoClienteException &&
            this.model.ExistemPedidosEmAbertoClienteException()
            ? global.isFormValid("#form-senha-orcamento-aberto")
            : true;

        var formVendedorRelacionadoValido = this.model.VendedorRelacionadoClienteDiferenteVendedorLogadoException &&
            this.model.VendedorRelacionadoClienteDiferenteVendedorLogadoException()
            ? global.isFormValid("#form-senha-vendedor-relacionado")
            : true;

        if (!formOrcamentoAbertoValido || !formVendedorRelacionadoValido) {
            return;
        }

        var self = this;

        global.ajax({
            url: "/Orcamento/AtualizarCliente",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoCliente: this.cliente.get("Codigo"),
                validarCliente: false,
                senha: this.model.SenhaOrcamentosAberto(),
                senhaVendedorRelacionado: this.model.SenhaVendedorRelacionado()
            }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.hide();
                self.clienteDefinidoCallback(self.cliente, data);
                $('html, body').animate({ scrollTop: $('html, body').offset().top }, 1000);
            }
        });

    }


});

window.PendenciaClienteOrcamentoController = PendenciaClienteOrcamentoController

export {
    PendenciaClienteOrcamentoController
}